<template>
  <b-container v-if="loaded" fluid class="p-0">
    <b-card class="mx-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="titulo-sagres font-weight-bold">
            Detalhes do Evento
          </span>
          <btn-voltar />
          <btn-excluir
            v-if="modoExclusao"
            :excluirItem="callExcluir"
            :idItem="1"
            botao
            class="float-right mt-1"
          />
        </h6>
      </template>
      <b-tabs card fill>
        <b-tab>
          <template #title>
            <font-awesome-icon
              icon="pencil"
              class="mr-1 text-info"
              v-b-tooltip.hover
              title="Dados do Evento"
            />
            <span class="d-none d-md-inline">Dados iniciais</span>
          </template>
          <div>
            <detalhes-dados-iniciais-evento :evento="evento" />
            <detalhes-anexos-evento :evento="evento" />
          </div>
        </b-tab>
        <b-tab lazy>
          <template #title>
            <font-awesome-icon
              icon="hourglass-end"
              class="mr-1 text-secondary"
              v-b-tooltip.hover
              title="Histórico"
            />
            <span class="d-none d-md-inline">Histórico</span>
          </template>
          <detalhes-historico-evento
            :idEvento="+idEvento"
          ></detalhes-historico-evento>
        </b-tab>
      </b-tabs>
    </b-card>
  </b-container>
</template>

<script lang="ts">
import DetalhesDadosIniciaisEvento from "@/components/licitacoes/eventos/DetalhesDadosIniciaisEvento.vue";
import DetalhesAnexosEvento from "@/components/licitacoes/eventos/DetalhesAnexosEvento.vue";
import DetalhesHistoricoEvento from "@/components/licitacoes/eventos/DetalhesHistoricoEvento.vue";
import BtnVoltar from "@/components/shared/BtnVoltar.vue";
import BtnExcluir from "@/components/shared/btn-excluir.vue";
import eventoService from "@/services/licitacoes/eventosService";
import { store } from "@/store";
import { fieldsLogsEventos } from "@/types/licitacoes/fields-logs-eventos";
import { LogEvento } from "@/types/licitacoes/log-evento";
import { TableField } from "@/types/table-field";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { Evento } from "@/types/eventos/eventos/evento";
import { TipoEvento } from "@/types/eventos/eventos/tipo-evento";

const CompProps = Vue.extend({
  name: "DetalhesEvento",
  components: {
    BtnExcluir,
    BtnVoltar,
    DetalhesDadosIniciaisEvento,
    DetalhesAnexosEvento,
    DetalhesHistoricoEvento,
  },
  props: {
    idEvento: {
      type: String,
      required: true,
    },
  },
});

@Component
export default class DetalhesEvento extends mixins(UtilsTS, CompProps) {
  tiposEvento: TipoEvento[] = [];
  loaded = false;
  tableBusy = false;
  evento: Evento = new Evento();
  itemsLogs: LogEvento[] = [];
  fieldsLogs: TableField[] = fieldsLogsEventos;
  currentPageLogs = 1;

  get modoExclusao() {
    return "excluir" in this.$route.query;
  }

  async mounted() {
    try {
      store.blockScreen = true;
      const responseTiposEvento = await eventoService.listarTiposEvento();
      this.tiposEvento = responseTiposEvento.data;
      this.evento = await eventoService.buscarEvento(this.idEvento);
      this.evento.tratarDadosDaAPI();
      this.evento.TipoEvento = this.tiposEvento.find(
        (x) => x.IdTipoEvento === this.evento.IdTipoEvento
      );
    } catch (e: any) {
      console.error("Erro ao montar detalhes do evento", e);
      this.$router.push("/modulo-eventos/eventos");
      this.$toast.error(e.message || "Erro ao carregar evento");
    } finally {
      this.loaded = true;
      store.blockScreen = false;
    }
  }

  async callExcluir() {
    try {
      store.blockScreen = true;
      const response = await eventoService.removerEvento(+this.idEvento);
      if (response) {
        this.$toast.success("Evento excluído com sucesso");
        this.$router.push("/modulo-eventos/eventos");
      } else {
        this.$toast.error("Erro ao excluir Evento");
      }
    } catch (error: any) {
      this.tratarError(error);
    } finally {
      store.blockScreen = false;
    }
  }
}
</script>

<style></style>